import React, { useEffect, useState, useRef } from "react";
import useReactRouter from "use-react-router"
import * as _ from "lodash"
import { Table, Button, Form, Tabs, Tab, Modal } from "react-bootstrap";
import { SHOPID, COLOR_APP, DEFAULT_SUMMARY_MESSAGE } from '../../constants'
import { useLazyQuery, useMutation } from "@apollo/client";
import { errorTitleWithTextSwal } from "../../helpers/sweetalert";
import { useToasts } from "react-toast-notifications";
import { GET_SETTINGS } from "../../graphql/setting/query";
import { useInitFbSDK } from "../../helpers/fb-hooks";
import MessengerIcon from "../../components/MessengerIcon";
import ErrorPermissionModal from "../../components/ErrorPermissionModal";

function UserCFMessenger({ userConfirm, closeMessengerModal }) {
    const { history } = useReactRouter()
    const { addToast } = useToasts()
    const isFbSDKInitialized = useInitFbSDK();

    const [fbUserAccessToken, setFbUserAccessToken] = useState();
    const [assignedPage, setAssignedPage] = useState();
    // const [userConfirm, setUserConfirm] = useState();
    const [shopSettings, setShopSettings] = useState([]);
    const [message, setMessage] = useState(DEFAULT_SUMMARY_MESSAGE);
    const [isLoading, setIsLoading] = useState(false);
    const [showErrorPermissionModal, setShowErrorPermissionModal] = useState(false);

    // const [getUserConfirmData, { data: userConfirmData }] = useLazyQuery(GET_USER_CONFIRMS, { fetchPolicy: "cache-and-network" });
    const [getSettings, { data: shopSettingData }] = useLazyQuery(GET_SETTINGS, { fetchPolicy: "cache-and-network" });

    React.useEffect(() => {
        connectFacebook()
        initSetting()
    }, [isFbSDKInitialized]);

    // React.useEffect(() => {
    //     // console.log(userConfirmData)
    //     if (userConfirmData) {
    //         setUserConfirm(userConfirmData.userConfirms.data[0])
    //         setIsLoading(false)
    //     }
    // }, [userConfirmData]);

    useEffect(() => {
        if (shopSettingData && shopSettingData?.settings?.data?.length > 0) {
            setShopSettings(shopSettingData?.settings?.data[0])
        }
    }, [shopSettingData])

    const initSetting = async () => {
        // setIsLoading(true)
        let SHOP_ID = await localStorage.getItem("SHOP");
        await getSettings({
            variables: {
                where: {
                    shop: SHOP_ID
                },
                orderBy: "createdAt_ASC"
            }
        })
    }


    const connectFacebook = async () => {
        // Checks if the user is logged in to Facebook
        window.FB.getLoginStatus((response) => {
            if (response.authResponse) setFbUserAccessToken(response.authResponse?.accessToken);
            else window.FB.login((response) => {
                // console.log(response)
                addToast("ເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກສໍາເລັດ", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                let hasPermission = true;
                ["public_profile", "email", "pages_read_engagement", "pages_show_list", "pages_messaging", "pages_manage_metadata", "pages_read_user_content"].map((_permisision) => {
                    if (!response.authResponse.grantedScopes.includes(_permisision)) hasPermission = false;
                })
                if (!hasPermission) {
                    addToast("ທ່ານຕ້ອງເປີດອະນຸຍາດໃຫ້ເຂົ້າເຖິງຂໍ້ມູນບໍ່ຄົບຖ້ວນ", {
                        appearance: "error",
                        autoDismiss: true,
                    });
                    setShowErrorPermissionModal(true)
                    return;
                }
                if (response.authResponse) setFbUserAccessToken(response.authResponse.accessToken);
                else errorTitleWithTextSwal("ມີຂໍ້ຜິດພາດ", "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ")
            }, {
                scope: `public_profile,email,
                         pages_show_list,
                         pages_read_engagement,
                         pages_manage_metadata,
                         pages_messaging,
                         pages_read_user_content`,
                return_scopes: true,
                auth_type: "rerequest"
            });
        });
    }

    // Fetches user pages
    React.useEffect(() => {
        if (fbUserAccessToken) {
            console.log("WOWOEK")
            window.FB.api(
                `/me/accounts?access_token=${fbUserAccessToken}`,
                async ({ data }) => {
                    // console.log({ data })
                    // console.log({ userConfirm })
                    let _seletedPage = data.filter((page) => page.id == userConfirm.pageId)
                    setAssignedPage(_seletedPage[0])
                }
            );

        }
    }, [fbUserAccessToken]);

    const _sendMessenger = () => {
        closeMessengerModal()

        //* POST_PURCHASE_UPDATE deprecated by Meta → HUMAN_AGENT (7-day) when enabled, else RESPONSE (24h).
        const _humanAgent = String(process.env.REACT_APP_HUMAN_AGENT_ENABLED || "").toLowerCase() === "true";
        let params = {
            "messaging_type": _humanAgent ? "MESSAGE_TAG" : "RESPONSE",
            ...(_humanAgent ? { "tag": "HUMAN_AGENT" } : {}),
            "recipient": {
                "id": userConfirm?.psid
            },
            "message": {
                "text": message
            }
        }
        window.FB.api(`/me/messages?access_token=${assignedPage?.access_token}`, "POST", params, async (res) => {
            // console.log(res)
            closeMessengerModal()
            addToast("ສົ່ງຂໍ້ຄວາມຫາລູກຄ້າສໍາເລັດ", {
                appearance: 'success',
                autoDismiss: true,
            })
        })
    }

    return (
        <div>
            <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                    as="textarea" rows={15}
                    placeholder="ລາຍລະອຽດຂໍ້ຄວາມທີ່ຕ້ອງການຈະສົ່ງຫາລູກຄ້າ..."
                    value={message || ""}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </Form.Group>

            {isLoading ? <div>ກໍາລັງໂຫຼດຂໍ້ມູນ</div> : <div onClick={() => { _sendMessenger() }} style={{ border: "1px solid #1877f2", color: "#1877f2", borderRadius: 12, width: 180, padding: 8, display: "flex", flexDirection: "row", justifyContent: "center", cursor: "pointer" }}>
                <MessengerIcon style={{ color: "#1877f2", fontSize: 20 }} />
                <div style={{ width: 12 }} />
                <p style={{ margin: 0 }}>ສົ່ງຂໍ້ຄວາມ</p>
            </div>}

            <ErrorPermissionModal showErrorPermissionModal={showErrorPermissionModal} setShowErrorPermissionModal={setShowErrorPermissionModal} />
        </div >
    );
}

export default UserCFMessenger;